import { forwardRef } from 'react';
import styles from '@/components/editor/components/mention/mention.module.css';

interface MentionProps {
	value: string;
	id: string;
	children?: React.ReactNode;
}

const Mention = forwardRef<HTMLSpanElement, MentionProps>(
	({ value, id, children, ...other }, ref) => {
		return (
			<span
				{...other}
				className={styles.mention}
				contentEditable={false}
				data-mention-id={id}
				data-mention-value={value}
				ref={ref}
				title={`@${value}`}
			>
				@{value}
				{children}
			</span>
		);
	}
);

Mention.displayName = 'Mention';

export default Mention;
